export const MAX_NUMBER_CHARS_EMAIL = 100;
export const MIN_NUMBER_CHARS_EMAIL = 8;
export const EMAIL_RULE = /\S+@\S+\.\S+/;
